<template>
  <h3 class="mt-0 mb-5 ml-0 mr-0 ds-text-base font-bold text-gray-700 uppercase whitespace-no-wrap">
    <slot></slot>
  </h3>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
